import fetch from '../apiconfig/index';
// 二进制导出
export function GetAllExpReport(params) {
	return fetch.getExl(`/api/v1/teacher/Exp/GetAllExpReport/?t=` + new Date().getTime(), params)
}
// 用户登陆
export function Login(params) {
	return fetch.post(`/api/User/Login/?t=`+new Date().getTime(), params);
}
// 注销用户
export function Logout(params) {
	return fetch.get(`/api/User/Logout/?t=`+new Date().getTime(), params);
}
// 判断实验ID是否存在

export function GetExpByIdMsg(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpByIdMsg/?t=`+new Date().getTime(), params);
}

//进入申报页面发送请求
export function publicTicket(params) {
    return fetch.post(`/api/public/ilab/ticket/?t=`+new Date().getTime(), params)
}
/* ==============================通用接口============================== */
// 获取教师负责班级信息
export function GetTchClass(params) {
	return fetch.get(`/api/v1/teacher/General/GetTchClass/?t=`+new Date().getTime(), params);
}
//获取教师课程id名称列表(无分页所有课程)
export function GetCoursesArr(params) {
	return fetch.get(`/api/v1/teacher/General/GetCoursesList/?t=`+new Date().getTime(), params);
}
// 获取学院课程id名称列表
export function GetCoursesAllByid(params) {
	return fetch.get(`/api/v1/teacher/General/GetCoursesAll/?t=`+new Date().getTime(), params);
}
//获取学院班级信息 /api/v1/teacher/General/GetCollegeClass/
export function GetCollegeClass(params) {
	return fetch.get(`/api/v1/teacher/General/GetCollegeClass/?t=`+new Date().getTime(), params);
}
// 获取学院列表
export function GetCollegeList(params) {
	return fetch.get(`/api/v1/teacher/General/GetCollegeList/?t=`+new Date().getTime(), params);
}

/* ==============================数据统计============================== */
// 获取校级统计数据
export function GetFieldCount(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldCount/?t=`+new Date().getTime(), params);
}
// 获取校级统计数据-实验列表
export function GetFieldExp(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldExp/?t=`+new Date().getTime(), params);
}
//学院统计数据-基础
export function GetFieldCollegeTj(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeTj/?t=`+new Date().getTime(), params);
}
// 学院统计数据-时间展示
export function GetFieldCollegeSj(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeSj/?t=`+new Date().getTime(), params);
}
// 学院统/教师计数据-成绩统计
export function GetFieldCollegeScore(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeScore/?t=`+new Date().getTime(), params);
}
// 学院统计数据-成绩分段统计
export function GetFieldCollegeScoreD(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldCollegeScoreD/?t=`+new Date().getTime(), params);
}
// 教师统计数据-本周教学任务
export function GetFieldTchCourse(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldTchCourse/?t=`+new Date().getTime(), params);
}
// 教师统计数据-学习近况
export function GetFieldTchCoursePH(params) {
	return fetch.get(`/api/v1/teacher/Count/GetFieldTchCoursePH/?t=`+new Date().getTime(), params);
}

/* ==============================课程接口============================== */
// 获取课程列表
export function GetCoursesList(params) {
	return fetch.get(`/api/v1/teacher/Courses/GetCoursesList/?t=`+new Date().getTime(), params);
}
// 添加课程信息
export function AddCourses(params) {
	return fetch.post(`/api/v1/teacher/Courses/AddCourses/?t=`+new Date().getTime(), params);
}
// 修改课程信息
export function AmendCourses(params) {
	return fetch.post(`/api/v1/teacher/Courses/GetCoursesById/?t=`+new Date().getTime(), params);
}
// 获取课程信息
export function GetCoursesById(params) {
	return fetch.get(`/api/v1/teacher/Courses/GetCoursesById/?t=`+new Date().getTime(), params);
}
// 删除课程信息
export function delCourses(params) {
	return fetch.get(`/api/v1/teacher/Courses/DelCoursesById/?t=`+new Date().getTime(), params);
}
/* ==============================教师资源接口============================== */

// 添加教师资源
export function AddResource(params) {
	return fetch.post(`/api/v1/teacher/Courses/AddResource/?t=`+new Date().getTime(), params);
}

//删除教师资源信息
export function DelResource(params) {
	return fetch.get(`/api/v1/teacher/Courses/DelResourceById/?t=`+new Date().getTime(), params);
}
/* ==============================虚拟实验接口============================== */
//获取虚拟仿真实验列表-分页
export function GetExperimentArr(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExperimentArr/?t=`+new Date().getTime(), params);
}
//获取仿真实验列表-本学院（全部实验）
export function GetExperimentList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExperimentList/?t=`+new Date().getTime(), params);
}

// 添加虚拟仿真实验全部信息
export function AddExperiment(params) {
	return fetch.post(`/api/v1/teacher/Exp/AddExperiment/?t=`+new Date().getTime(), params);
}
// 获取仿真实验信息相关
export function GetExpById(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpById/?t=`+new Date().getTime(), params);
}
// 修改仿真实验相关信息AmendExperiment
export function AmendExperiment(params) {
	return fetch.post(`/api/v1/teacher/Exp/UpExpById/?t=`+new Date().getTime(), params);
}
//删除虚拟仿真实验信息
export function DelExperiment(params) {
	return fetch.get(`/api/v1/teacher/Exp/DelExperimentById/?t=`+new Date().getTime(), params);
}
/* ==============================虚拟仿真实验申报详情页面接口============================== */
// 获取虚拟信息统计
export function GetExperiment(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExperiment/?t=`+new Date().getTime(), params);
}
// 获取仿真实验成绩列表
export function GetScoreList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetScoreList/?t=`+new Date().getTime(), params);
}
// 获取团队成员列表
export function GetExpDecTeamList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpDecTeamList/?t=`+new Date().getTime(), params);
}
/* ==============================实验报告管理接口============================== */
// 获取学生实验报告列表
export function GetExpReportList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpReportList/?t=`+new Date().getTime(), params);
}
// 获取学生实验报告信息
export function GetExpReportById(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpReportById/?t=`+new Date().getTime(), params);
}
// 点评学生报告信息
export function GetExpReport(params) {
	return fetch.post(`/api/v1/teacher/Exp/GetExpReportById/?t=`+new Date().getTime(), params);
}
/* ==============================成绩统计接口============================== */
// 获取成绩统计信息
export function GetScore(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetScore/?t=`+new Date().getTime(), params);
}
// 获取实验学生列表
export function GetStuList(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetStuList/?t=`+new Date().getTime(), params);
}
//

export function GetExpReportArr(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetExpReportArr/?t=`+new Date().getTime(), params);
}

/* ==============================考试系统接口============================== */
// 获取试题列表
export function GetQuestionsList(params) {
	return fetch.get(`/api/v1/teacher/Test/GetQuestionsList/?t=`+new Date().getTime(), params);
}
// 添加试题信息
export function AddQuestions(params) {
	return fetch.post(`/api/v1/teacher/Test/AddQuestions/?t=`+new Date().getTime(), params);
}
// 修改试题信息
export function AmendQuestions(params) {
	return fetch.post(`/api/v1/teacher/Test/GetQuestionsById/?t=`+new Date().getTime(), params);
}
// 删除试题信息
export function delQuestions(params) {
	return fetch.get(`/api/v1/teacher/Test/DelQuestionsById/?t=`+new Date().getTime(), params);
}
// 获取试题信息
export function getQuestionsById(params) {
	return fetch.get(`/api/v1/teacher/Test/GetQuestionsById/?t=`+new Date().getTime(), params);
}
//添加移除课后巩固
export function GetIsExec(params) {
	return fetch.get(`/api/v1/teacher/Test/GetIsExec/?t=`+new Date().getTime(), params);
}
// 获取课后巩固列表
export function GetExpIsExecList(params) {
	return fetch.get(`/api/v1/teacher/Test/GetExpIsExecList/?t=`+new Date().getTime(), params);
}
/* ==============================试卷列表接口============================== */
// 获取试卷列表
export function GetTestPaperList(params) {
	return fetch.get(`/api/v1/teacher/Test/GetTestPaperList/?t=`+new Date().getTime(), params);
}
// 获取试卷信息
export function GetTestPaperById(params) {
	return fetch.get(`/api/v1/teacher/Test/GetTestPaperById/?t=`+new Date().getTime(), params);
}
// 添加试卷信息下发试卷
export function AddTestPaper(params) {
	return fetch.post(`/api/v1/teacher/Test/AddTestPaper/?t=`+new Date().getTime(), params);
}
// 修改试卷信息
export function AmendTestPaper(params) {
	return fetch.post(`/api/v1/teacher/Test/GetTestPaperById/?t=`+new Date().getTime(), params);
}
//删除试卷信息
export function delTestPaper(params) {
	return fetch.get(`/api/v1/teacher/Test/DelTestPaper/?t=`+new Date().getTime(), params);
}
//获取题型数量(根据课程ID获取题型数量)
export function GetTiNumObj(params) {
	return fetch.get(`/api/v1/teacher/Test/GetTiNum/?t=`+new Date().getTime(), params);
}
// 自动组卷-试卷生成预览
export function AddRandomList(params) {
	return fetch.post(`/api/v1/teacher/Test/AddRandomList/?t=`+new Date().getTime(), params);
}
// 获取试卷-试题列表
export function GetTestPaperQueList(params) {
	return fetch.get(`/api/v1/teacher/Test/GetTestPaperQueList/?t=`+new Date().getTime(), params);
}

/*+++++++++++++++++++++++++++++++++++++++实验室++++++++++++++++++++++++++++++++++++++++++ */
/* ==============================楼栋接口============================== */
// 获取楼栋列表无分页
export function GetAllBuild(params) {
	return fetch.get(`/api/v1/teacher/Build/GetBuild/?t=`+new Date().getTime(), params);
}
// 获取楼栋列表
export function GetBuildList(params) {
	return fetch.get(`/api/v1/teacher/Build/GetBuildList/?t=`+new Date().getTime(), params);
}
// 添加楼栋信息
export function AddBuild(params) {
	return fetch.post(`/api/v1/teacher/Build/AddBuild/?t=`+new Date().getTime(), params);
}
// 修改楼栋信息
export function AmendBuild(params) {
	return fetch.post(`/api/v1/teacher/Build/GetBuildById/?t=`+new Date().getTime(), params);
}
// 获取楼栋信息
export function GetBuildById(params) {
	return fetch.get(`/api/v1/teacher/Build/GetBuildById/?t=`+new Date().getTime(), params);
}
// 删除楼栋信息
export function delBuild(params) {
	return fetch.get(`/api/v1/teacher/Build/DelBuildById/?t=`+new Date().getTime(), params);
}

/* ==============================楼层接口============================== */
// 获取楼层列表-无分页
export function GetFloorArr(params) {
	return fetch.get(`/api/v1/teacher/Build/GetFloorArr/?t=`+new Date().getTime(), params);
}
// 获取楼层列表
export function GetFloorList(params) {
	return fetch.get(`/api/v1/teacher/Build/GetFloorList/?t=`+new Date().getTime(), params);
}
// 添加楼层信息
export function AddFloor(params) {
	return fetch.post(`/api/v1/teacher/Build/AddFloor/?t=`+new Date().getTime(), params);
}
// 修改楼层信息
export function AmendFloor(params) {
	return fetch.post(`/api/v1/teacher/Build/GetFloorById/?t=`+new Date().getTime(), params);
}
// 获取楼层信息
export function GetFloorById(params) {
	return fetch.get(`/api/v1/teacher/Build/GetFloorById/?t=`+new Date().getTime(), params);
}
// 删除楼层信息
export function delFloor(params) {
	return fetch.get(`/api/v1/teacher/Build/DelFloorById/?t=`+new Date().getTime(), params);
}

/* ==============================实验室接口============================== */
// 获取实验室列表-无分页
export function GetRoomArr(params) {
	return fetch.get(`/api/v1/teacher/Build/GetRoomArr/?t=`+new Date().getTime(), params);
}
// 获取实验室列表
export function GetRoomList(params) {
	return fetch.get(`/api/v1/teacher/Build/GetRoomList/?t=`+new Date().getTime(), params);
}
// 添加实验室信息
export function AddRoom(params) {
	return fetch.post(`/api/v1/teacher/Build/AddRoom/?t=`+new Date().getTime(), params);
}
// 修改实验室信息
export function AmendRoom(params) {
	return fetch.post(`/api/v1/teacher/Build/GetRoomById/?t=`+new Date().getTime(), params);
}
// 获取实验室信息
export function GetRoomById(params) {
	return fetch.get(`/api/v1/teacher/Build/GetRoomById/?t=`+new Date().getTime(), params);
}
// 删除实验室信息
export function delRoom(params) {
	return fetch.get(`/api/v1/teacher/Build/DeiRoomById/?t=`+new Date().getTime(), params);
}

/* ==============================实验室设备接口============================== */

// 获取设备列表-实验室可用设备
export function GetEquipmentUsable(params) {
	return fetch.get(`/api/v1/teacher/YuYue/GetEquipmentUsable/?t=`+new Date().getTime(), params);
}
// 根据房间ID获取实验室设备列表
export function GetEquipmentByRoomId(params) {
	return fetch.get(`/api/v1/teacher/Build/GetEquipmentRoomId/?t=`+new Date().getTime(), params);
}
//获取设备列表-无分页
export function GetEquipmentArr(params) {
	return fetch.get(`/api/v1/teacher/Build/GetEquipmentArr/?t=`+new Date().getTime(), params);
}
//获取设备列表
export function GetEquipmentList(params) {
	return fetch.get(`/api/v1/teacher/Build/GetEquipmentList/?t=`+new Date().getTime(), params);
}
// 添加设备信息
export function AddEquipment(params) {
	return fetch.post(`/api/v1/teacher/Build/AddEquipment/?t=`+new Date().getTime(), params);
}
// 修改设备信息
export function AmendEquipment(params) {
	return fetch.post(`/api/v1/teacher/Build/GetEquipmentById/?t=`+new Date().getTime(), params);
}
// 获取设备信息
export function GetEquipmentById(params) {
	return fetch.get(`/api/v1/teacher/Build/GetEquipmentById/?t=`+new Date().getTime(), params);
}
// 删除设备信息
export function delEquipment(params) {
	return fetch.get(`/api/v1/teacher/Build/DelEquipmentById/?t=`+new Date().getTime(), params);
}

/* ==============================耗材接口============================== */
//获取耗材列表-有分页
export function GetConsumablesList(params) {
	return fetch.get(`/api/v1/teacher/Build/GetConsumablesList/?t=`+new Date().getTime(), params);
}
//获取耗材列表-无分页
export function GetConsumablesArr(params) {
	return fetch.get(`/api/v1/teacher/Build/GetConsumablesArr/?t=`+new Date().getTime(), params);
}
// 添加耗材信息
export function AddConsumables(params) {
	return fetch.post(`/api/v1/teacher/Build/AddConsumables/?t=`+new Date().getTime(), params);
}
// 修改耗材信息
export function AmendConsumables(params) {
	return fetch.post(`/api/v1/teacher/Build/GetConsumablesById/?t=`+new Date().getTime(), params);
}
// 获取耗材信息
export function GetConsumablesById(params) {
	return fetch.get(`/api/v1/teacher/Build/GetConsumablesById/?t=`+new Date().getTime(), params);
}
// 删除耗材信息
export function delConsumables(params) {
	return fetch.get(`/api/v1/teacher/Build/DelConsumablesById/?t=`+new Date().getTime(), params);
}
/* ==============================实验室预约============================== */
// 添加在线预约信息
export function AddAppointment(params) {
	return fetch.post(`/api/v1/teacher/YuYue/AddAppointment/?t=`+new Date().getTime(), params);
}
// 获取在线预约结果列表(个人)
export function GetAppointmentByIdList(params) {
	return fetch.get(`/api/v1/teacher/YuYue/GetAppointmentByIdList/?t=`+new Date().getTime(), params);
}
//取消预约申请(个人)
export function GetCancelById(params) {
	return fetch.get(`/api/v1/teacher/YuYue/GetCancelById/?t=`+new Date().getTime(), params);
}
//获取审批结果列表(管理)
export function GetAppointmentList(params) {
	return fetch.get(`/api/v1/teacher/YuYue/GetAppointmentList/?t=`+new Date().getTime(), params);
}
//获取在线预约信息(管理)
export function GetAppointmentById(params) {
	return fetch.get(`/api/v1/teacher/YuYue/GetAppointmentById/?t=`+new Date().getTime(), params);
}
//在线预约审核操作(管理)
export function examine(params) {
	return fetch.post(`/api/v1/teacher/YuYue/GetAppointmentById/?t=`+new Date().getTime(), params);
}
/* ==============================发布公告设置============================== */
// 获取已发布公告列表
export function GetMessageList(params) {
	return fetch.get(`/api/v1/teacher/Msg/GetMessageList/?t=`+new Date().getTime(), params);
}
// 发布公告信息
export function AddMessage(params) {
	return fetch.post(`/api/v1/teacher/Msg/AddMessage/?t=`+new Date().getTime(), params);
}

/* ==============================账号设置============================== */
// 修改账号密码
export function NewPwd(params) {
	return fetch.post(`/api/public/User/NewPwd/?t=`+new Date().getTime(), params);
}
//获取手机号信息
export function GetPhone(params) {
	return fetch.get(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params);
}
//修改新手机号
export function NewPhone(params) {
	return fetch.post(`/api/public/User/GetPhone/?t=`+new Date().getTime(), params);
}
// 获取仿真实验列表-学院
export function publicGetExperimentList(params) {
	return fetch.get(`/api/public/General/GetExperimentList/?t=`+new Date().getTime(), params);
}

// 获取仿真实验列表-学院
export function GetScoreXlsDownload(params) {
	return fetch.get(`/api/v1/teacher/Exp/GetScoreXlsDownload/?t=`+new Date().getTime(), params);
}


// 获取仿真实验列表-学院
export function GetExcel(params) {
	return fetch.get(`/api/v1/teacher/Count/Exp/Excel/?t=`+new Date().getTime(), params);
}
